import { api } from '../../../utils/api.ts';

export function useCrmConfig() {
    return api.platoUser.query.appConfig.getCrmConfig.useQuery();
}
